import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import "./Layout.css";

function Layout({ onLogout, user }) {
  return (
    <div className="dashboard">
      {/* Sidebar fijo a la izquierda */}
      <Sidebar user={user} /> {/* opcional: también puedes mostrar el nombre/foto aquí */}

      {/* Contenedor principal: Topbar + contenido */}
      <div className="main-container">
        <Topbar onLogout={onLogout} user={user} /> {/* ✅ recibe props globales */}
        <main className="main-content">
          <Outlet /> {/* Aquí se renderizan las páginas como Dashboard, Obsequios, etc */}
        </main>
      </div>
    </div>
  );
}

export default Layout;
